import React from "react";
import './ElementalsConstructionToken.css'

const ElementalsConstructionToken = ({tokenName, isUsed}) => {

  return (
    <img
      className={'elementals-construction-token-img'}
      src={`/img/icons/element_${tokenName}.png`}
      alt={tokenName}
      style={{opacity: isUsed ? 0.5 : 1}}
    />
  )
}

export default ElementalsConstructionToken;